/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.PALMOS_INDEX = {

  '@AC': 
  [
     'acer-momo',
     'acer-coco',
     'Acea-MZ01',
     'Acea-PD01',
  ],
  '@GR': 
  [
     'grmn-3200',
     'grmn-3600',
     'grmn-3700',
  ],
  '@GS': 
  [
     'gsRl-zicn',
     'gsRl-zcn2',
     'gsRl-zcn5',
  ],
  '@HS': 
  [
     'hspr-H101',
     'hspr-H102',
  ],
  '@KW': 
  [
     'kwc.-7135',
  ],
  '@PA': 
  [
     'Palm-D061',
     'Palm-D062',
     'Palm-TunX',
     'Palm-stuj',
     'Palm-hbbs',
     'Palm-trnd',
     'Palm-ecty',
     'Palm-lith',
     'Palm-sky1',
     'Palm-D053',
     'Palm-D052',
     'Palm-D060',
     'Palm-MT64',
     'Palm-Cct1',
     'Palm-Zir4',
     'Palm-Frg1',
     'Palm-Frg2',
     'Palm-Arz1',
     'Palm-TnT5',
     'Palm-atc1',
     'Palm-D050',
     'Palm-Cubs',
     'Palm-Zi21',
     'Palm-D051',
     'Palm-Zi22',
     'Palm-Zpth',
     'Palm-Zi72',
  ],
  '@QC': 
  [
     'qcom-qc20',
  ],
  '@SM': 
  [
     'smsn-phix',
     'smsn-Phx2',
     'smsn-blch',
     'smsn-BLFM',
     'smsn-glxy',
  ],
  '@SO': 
  [
     'sony-ystn',
     'sony-ysmt',
     'sony-ysm2',
     'sony-nsca',
     'sony-nsc2',
     'sony-vnce',
     'sony-mdna',
     'sony-npls',
     'sony-rdwd',
     'sony-crdb',
     'sony-tldo',
     'sony-mdrd',
     'sony-grnd',
     'sony-frta',
     'sony-cocs',
     'sony-glps',
     'sony-mcnd',
     'sony-vrna',
     'sony-atom',
     'sony-goha',
     'sony-leia',
     'sony-hwai',
     'sony-goku',
     'sony-luke',
     'sony-amno',
     'sony-prmr',
     'sony-ancy',
  ],
  '@TP': 
  [
     'Tpwv-Rdog',
  ],
  '@TR': 
  [
     'trgp-trg1',
     'trgp-trg2',
  ],
};

/* This file is automatically generated, do not edit manually! */
